import React from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import _Button from "../../../generic/_Button";
import { useQuery } from "@tanstack/react-query";
import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { useAuth } from "../../../../Context/AuthContext";
import { Table } from "../../../ui/Table";
import { FormatInt } from "../../../../utils/FormatData";

const formatHours = (value) => {
  const hour = Number(value);
  const period = hour < 12 ? "a.m." : "p.m.";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12}:00 ${period}`;
};

const columns = [
  {
    Header: "Carrier",
    accessor: "vc_carrier",
  },
  {
    Header: "Hora",
    accessor: "i_hora",
    Cell: (rowData) => {
      let value = rowData.row.original.i_hora;

      return formatHours(value);
    },
  },
  {
    Header: "Código Error",
    accessor: "vc_error",
  },
  {
    Header: "SMS",
    accessor: "i_sms",
    Cell: (rowData) => {
      let value = rowData.row.original.i_sms;

      return FormatInt(value);
    },
  },
  {
    Header: "Errores",
    accessor: "i_errors",
    Cell: (rowData) => {
      let value = rowData.row.original.i_errors;

      return FormatInt(value);
    },
  },
];

const _ModalError = (props) => {
  const { visible = false, onClose, title = "", loading = false } = props;
  const auth = useAuth();
  const { token } = auth.getSessionData();
  const { isPending, data } = useQuery({
    queryKey: ["errorApi"],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}dashboard/resultssmsdetail`,
        {},
        token,
      );
      return await response.data;
    },
    enabled: visible,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  const _onClose = () => {
    if (onClose) onClose();
  };
  return (
    <Modal show={visible} onHide={_onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="text-xl font-semibold text-gray-600">{title}</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          columns={columns}
          data={data}
          loading={isPending}
          config={{
            search: true,
            pageSize: 10,
            perPage: 10,
            pagination: true,
            rowInfo: false,
            navButtons: false,
            rowsPerPageSelection: false,
            footer: true,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <_Button
          title="Cerrar"
          style="primary"
          onClick={_onClose}
          loading={loading}
          disabled={loading}
        />
      </Modal.Footer>
    </Modal>
  );
};

_ModalError.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  loading: PropTypes.bool,
};
export default _ModalError;
